Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.ClippingContentFactory

  create: (socialContent, allTags) ->
    content = new Monitoring.Models.SocialContents.ClippingContent(socialContent)
    content.set({ possibleTags: allTags })
    return content

  canHandle: (socialContent) ->
    return socialContent.group_type == 'inbox' and socialContent.data and socialContent.data.content and socialContent.data.sub_type == 'clipping'